const notification = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_NOTIFICATION':
      if (typeof state.priority === 'undefined') {
        return action.notification;
      }
      return state.priority <= action.notification.priority ? action.notification : state;

    case 'REMOVE_NOTIFICATION':
      return state.uid === action.uid ? {} : state;

    default:
      return state;
  }
};

export default notification;
